import React, { useEffect } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { InputText } from 'primereact/inputtext'
import { connect } from 'react-redux'
import {
  Btn,
  HeaderText,
  InputNumeroDecimal,
  OcorrenciasDropdown,
  UploadMultFileBtn,
} from '../../../../../components'
import { tableCellCentered } from '../../../../../assets/js/styles'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import useSobrasManual, { LOAD_MESSAGE } from './SobrasManualHook'
import {
  urlFotosSobra,
  urlUploadFotoSobra,
} from '../../../../../services/api/routes/picking.routes'
import ModalFotosOcorrencias from '../ModalFotosOcorrencias/ModalFotosOcorrencias'

function SobrasManual({ dispatch, selectedPicking, leftover_products, reasons }) {
  const { state, localDispatch } = useSobrasManual()

  useEffect(() => {
    localDispatch.onInit(leftover_products)
  }, [leftover_products])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.SAVE_SOBRAS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.saveSobrasSeparacaoManual(state.produtos, selectedPicking.id)
        break

      case LOAD_MESSAGE.SAVE_SOBRAS_SUCCESS:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage), null)
        break

      case LOAD_MESSAGE.FILE_UPLOADED:
        localDispatch.saveSobrasSeparacaoManual(state.produtos, selectedPicking.id)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  const header = (
    <div style={{ textAlign: 'left' }}>
      <i className="pi pi-search" style={{ margin: '4px 4px 0 0' }}></i>
      <InputText
        value={state.globalFilter}
        onChange={e => localDispatch.onGlobalFilterChange(e.target.value)}
        placeholder="Pesquisar . . ."
        size="50"
      />
    </div>
  )

  return (
    <div>
      <HeaderText>Apontamento das Sobras Apuradas</HeaderText>
      <div className="p-grid">
        <div className="p-col-2">
          <Btn
            disabled={state.btnSalvarDisabled}
            onClick={() => localDispatch.onBtnSalvarClicked(selectedPicking.status)}
          >
            Salvar
          </Btn>
        </div>
      </div>
      <DataTable
        value={state.produtos}
        paginator={true}
        rows={20}
        header={header}
        globalFilter={state.globalFilter}
        className="auto-layout"
      >
        <Column field="product_code" header="Código" style={tableCellCentered(200)} />
        <Column field="product_name" header="Produto" />
        <Column
          header="Ocorrência"
          style={tableCellCentered(320)}
          body={sobra => {
            return (
              <OcorrenciasDropdown
                disabled={state.btnAssociarDisabled}
                style={{ width: '100%' }}
                optionLabel="name"
                value={sobra.missing_reason}
                options={reasons}
                onChange={({ value }) => localDispatch.onDropdownChange(sobra, value)}
                placeholder="Selecione o Tipo de Ocorrência"
              />
            )
          }}
        />
        <Column
          header="Qte Sobras"
          style={tableCellCentered(100)}
          body={produto => (
            <InputNumeroDecimal
              marginTop={0}
              showLabel={false}
              value={produto.qte_leftover}
              onChange={value => localDispatch.onSobraInputChange(produto, value)}
              width={80}
            />
          )}
        />
        <Column
          header="Fotos"
          body={item => (
            <Btn
              onClick={() => localDispatch.onVerFotosClicked(item)}
              disabled={!item.files.length}
            >
              Ver Fotos ({item.files.length})
            </Btn>
          )}
          style={tableCellCentered(120)}
        />
        <Column
          header=""
          style={tableCellCentered(160)}
          body={item => {
            let disabled = true

            const entrega = leftover_products.find(p => p.product_id === item.product_id)
            disabled = !(entrega.missing_reason !== '' || entrega.qte_leftover !== '')

            return (
              <div style={{ position: 'relative', top: '-20px' }}>
                <UploadMultFileBtn
                  label="Anexar Fotos"
                  name="sobras"
                  accept="image/*"
                  disabled={disabled}
                  url={urlUploadFotoSobra()}
                  onUploadCompleted={file_name => localDispatch.onUploadCompleted(file_name, item)}
                />
              </div>
            )
          }}
        />
      </DataTable>
      <ModalFotosOcorrencias
        show={state.modal.show}
        onModalClose={localDispatch.onModalClose}
        data={state.modal.data}
        selectedPicking={selectedPicking}
        onDelete={localDispatch.onDeleteFoto}
        urlFoto={urlFotosSobra}
      />
    </div>
  )
}

const mapStateToProps = ({ picking: { selectedPicking } }) => ({ selectedPicking })
export default connect(mapStateToProps)(SobrasManual)
